export default __webpack_public_path__ + "static/media/dashboard_lenders.ee080b27.png";